<template >
	<div v-if="isOpen"  class="modal" >
		<div class="delete-modal-box ">
			<div class="modal-header">
				<span class="modal-title">Cancel subscription</span>
				<span class="modal-close" @click="$emit('update:isOpen', false)">&#10005;</span>
			</div>
			<div class="cancel-modal-content">
				<p>Do you really want to cancel your subscription? Without a subscription you will not have access to details of your deals. Your data will be deleted after 90 days</p>
				<p>Please, select a reason, why you cancel subscription.</p>
				<c-select2
					v-model='reason'
					:label="'Reason'"
					:options='reasonOptions'
				/>
				<div class='item'>
					<label class='input'>
						<textarea v-model="comment"></textarea>
						<span class='input__labels'
							:data-label='"Comment (optional)"'
						></span>
					</label>
				</div>
			</div>
			<div class="modal-footer">
				<button class='btn profile-ghost-btn modal-close' @click="$emit('update:isOpen', false)">Cancel</button>
				<button class='btn btn--danger modal-close' :disabled="!reason" @click="onConfirm">Continue to cancel</button>
			</div>
		</div>
	</div>
</template>

<script >
import cSelect2 from '__jsVueUI/c-select2/c-select2.vue';

export default {
	name:  'CancelSubscriptionModal',
	props: {
		isOpen: Boolean,
	},
	components: {
		'c-select2': cSelect2
	},
	data() {
		return {
			reason:        '',
			comment:       '',
			reasonOptions: [
				{
					value: 'too_complicated',
					label: 'The product is too complicated',
				},
				{
					value: 'unable_to_finalize_deals',
					label: "I'm unable to finalize deals",
				},
				{
					value: 'closed_all_deals',
					label: 'I closed all deals',
				},
				{
					value: 'other',
					label: 'Other',
				}
			]
		};
	},
	methods: {
		onConfirm() {
			if (this.reason) {
				this.$emit('onConfirm', { reason: this.reason, comment: this.comment });
				this.reason = '';
				this.comment = '';
				this.$emit('update:isOpen', false);
			}
		}
	}
};
</script>
